import { TDimensionType } from '../../types/types';

export type TRole =
  | 'account_admin'
  | 'owner'
  | 'admin'
  | 'moderator'
  | 'creator'
  | 'custom_creator'
  | 'player';
export const fromRoute = {
  dataViewer: 'dataViewer',
};
export const navigatetTo = {
  home: 'home',
  login: 'login',
  updateProfile: 'updateProfile',
  settings: 'settings',
  tvDisplay: 'tvDisplay',
};
export const AxisType = {
  Row: 'Row',
  Column: 'Column',
  Measure: 'Measure',
  Dimension: 'Dimension',
  SplitBy: 'Split By',
  X: 'X Axis',
  Y: 'Y Axis',
  ChartFilter: 'Filter',
  Location: 'Location',
  Date: 'Date',
  Distribution: 'Distribution',
};
export const roles = {
  AccountAdmin: 'account_admin',
  Admin: 'admin',
  Owner: 'owner',
  Moderator: 'moderator',
  Creator: 'creator',
  CustomCreator: 'custom_creator',
  Player: 'player',
  Community: 'community',
};
export const roleIds = {
  AccountAdmin: 1,
  Admin: 2,
  Owner: 3,
  Moderator: 4,
  Creator: 5,
  CustomCreator: 6,
  Player: 7,
  Community: 8,
};

export const permissions = {
  create: 1,
  edit: 2,
  view: 3,
  noPermission: null,
  restricted: 0,
};
export const contentTypes = {
  Dataset: 3,
  DataConnection: 2,
  FlatFile: 4,
  Playbook: 5,
  Workspace: 1,
};
export const messages = {
  dataset: {
    wrongName:
      'Dataset name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
    tableWrongName:
      'Table name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
  },
  dataConnection: {
    wrongName:
      'DB Connection name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
  },
  flatfile: {
    wrongName:
      'Flatfile name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
  },
  playbook: {
    wrongName:
      'Playbook name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
    WindowFunctionRemoved: 'Window functions are removed as dimensions are changed.',
    RemovingFilter: 'Filters with aggregation types are removed as there is nothing in dimension.',
    // FilterGroupBelongsToOtherDataset:"There cannot be more than one dataset per filter group.\nYou can create a new filter group and add this column."
    FilterGroupBelongsToOtherDataset:
      "A filter group can have only one dataset. As this field is coming from a different dataset, you can't add in here.\nYou can create a new filter group and add it.",
  },
  chart: {
    excessiveData: 'Too many data points returned from the query. We are limiting to top ',
    excessiveCalendarChartData:
      'Too many data points returned from the query. We are limiting to most recent 10 years of data.',
  },
  workspace: {
    wrongName:
      'File name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
  },
  formula: {
    cyclicDependency: 'Cyclic dependency detected. Please correct the formula.',
    wrongName: 'Calculation name should not contain any special characters except underscore.',
  },
};

export const DragFrom = {
  TABLE: 99,
};
export const DropTo = {
  MEASURE: 'Measure',
  DIMENSION: 'Dimension',
  CHART_FILTER: 'Filter',
  X: 'X',
  Y: 'Y',
  ROW: 'Row',
  COLUMN: 'Column',
  SPLIT_BY: 'Split By',
  LOCATION: 'Location',
};
export const Area = {
  MEASURE: 'Measure',
  CHART_FILTER: 'Filter',
  TABLE: 'Table',
  CALCULATION_CANVAS: 'CalculationCanvas',
};
export const DimensionType = {
  ROW: 'row' as const,
  COLUMN: 'column' as const,
  DIMENSION: 'dim' as const,
  SPLIT: 'split' as const,
};
